"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFilterForm = void 0;
const React = require("react");
const monthSelect_1 = require("flatpickr/dist/plugins/monthSelect");
const Button_1 = require("../Button");
const DatePicker_1 = require("../DatePicker");
const Check_1 = require("../FormElements/Check");
const CustomSelect_1 = require("../FormElements/CustomSelect");
const Radio_1 = require("../FormElements/Radio");
const form_validations_type_1 = require("../../utils/validations/form-validations.type");
const Spinner_1 = require("../Spinner");
const moment_dates_1 = require("../../utils/dates/moment-dates");
const form_type_1 = require("./form.type");
const constants_1 = require("../../utils/constants");
const form_utils_1 = require("../../utils/form.utils");
const BronsonFilterForm = ({ formId, catalogs, onChangeDataForm, formProvider, searchButton, dataForm, }) => {
    const spinner = () => (React.createElement(React.Fragment, null,
        React.createElement("br", null),
        React.createElement(Spinner_1.BronsonSpinner, { config: {
                spinnerWrapperClassModifier: 'c-spinner--center',
                showSpinner: true,
            } })));
    const boldString = (value) => {
        return React.createElement("b", null, value);
    };
    const customSelectElement = (field) => {
        let option;
        const options = catalogs &&
            catalogs[field.catalog] &&
            catalogs[field.catalog].catalog.map((catalogItem) => ({
                id: catalogItem[field.optionId],
                value: field.optionValue
                    .map((value) => catalogItem[value])
                    .join(' - '),
            }));
        const getOption = (term) => {
            option = options.filter((option) => {
                return option.id.toString() === term.toString();
            })[0];
            if (!option && field.writable && dataForm) {
                option = {
                    value: dataForm[field.elementId],
                };
            }
        };
        if (dataForm && dataForm[field.elementId]) {
            getOption(dataForm[field.elementId]);
        }
        if (field.defaultValue) {
            getOption(field.defaultValue);
        }
        return (React.createElement(CustomSelect_1.BronsonFormCustomSelect, { defaultValue: option ? option.value : form_type_1.defaultValue, elementId: field.elementId, placeholder: field.placeholder, writable: field.writable || false, label: field.boldLabel ? boldString(field.label) : field.label, maxLength: field.max, isDisabled: field.isDisabled, icon: 'semantic-search', tabIndex: 0, options: options, onClick: (option, hasError) => {
                let value = option.id;
                if (field.writable && value === undefined && option) {
                    value = option.toString();
                }
                onChangeDataForm(field.elementId, value, hasError);
            }, hasError: field.error || false, errorMessage: field.error || '', validations: field.validations &&
                field.validations.map((type) => {
                    return form_validations_type_1.BronsonFormValidationsEnum[type];
                }) }));
    };
    const selectElement = (field) => {
        var _a;
        return (React.createElement(form_utils_1.WrapperBronsonFormSelect, { defaultValue: dataForm && dataForm[field.elementId]
                ? dataForm[field.elementId]
                : (_a = field.defaultValue) !== null && _a !== void 0 ? _a : form_type_1.defaultValue, onChange: (event) => onChangeDataForm(field.elementId, event.value, event.hasError), isDisabled: field.isDisabled, label: field.boldLabel ? boldString(field.label) : field.label, elementId: field.elementId, hasError: field.catalog && catalogs[field.catalog].error, errorMessage: field.catalog && catalogs[field.catalog].errorMessage, validations: field.validations &&
                field.validations.map((type) => {
                    return form_validations_type_1.BronsonFormValidationsEnum[type];
                }) },
            React.createElement("option", { value: '' }, field.placeholder),
            field.catalog &&
                catalogs[field.catalog] &&
                catalogs[field.catalog].catalog.map((elem, index) => (React.createElement("option", { key: index, value: elem[field.catalogId] }, elem[field.catalogName])))));
    };
    const textElement = (field) => {
        return (React.createElement(form_utils_1.WrapperBronsonFormInput, { key: field.elementId, maxLength: field.max, defaultValue: dataForm && dataForm[field.elementId]
                ? dataForm[field.elementId]
                : field.defaultValue || form_type_1.defaultValue, onChange: (event) => onChangeDataForm(field.elementId, event.value, event.hasError), minLength: field.min || constants_1.zero, placeholder: field.placeholder, label: field.boldLabel ? boldString(field.label) : field.label, elementId: field.elementId, isDisabled: field.isDisabled, type: field.type, isUpperCase: field.isUpperCase, validations: field.validations &&
                field.validations.map((type) => {
                    return form_validations_type_1.BronsonFormValidationsEnum[type];
                }), hasError: !!field.error, errorMessage: field.error, autoFill: field.autoFill, pasting: field.pasting, autocomplete: field.autocomplete, startsWith: field.startsWith }, field.children));
    };
    const radioButtonElement = (field) => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement("label", null,
                field.boldLabel ? boldString(field.label) : field.label,
                ((_a = field.validations) === null || _a === void 0 ? void 0 : _a.includes('required')) && (React.createElement("span", { style: { color: 'red' } }, "\u00A0*"))),
            React.createElement("div", { className: 'o-inline-group' }, catalogs &&
                catalogs[field.catalog] &&
                catalogs[field.catalog].catalog.map((elem, index) => (React.createElement("div", { key: `group-${index}`, className: 'o-inline-group__item' },
                    React.createElement(Radio_1.BronsonFormRadio, { key: index, elementId: `${field.elementId}-${index}`, group: `group-${field.elementId}`, checked: (dataForm &&
                            dataForm[field.elementId] &&
                            dataForm[field.elementId].includes(elem[field.catalogId])) ||
                            false, isDisabled: field.isDisabled ||
                            elem['disabledOption'] ||
                            false, defaultValue: elem[field.catalogId] ||
                            elem[field.catalogName], label: elem[field.catalogName], onChange: (change) => {
                            onChangeDataForm(field.elementId, change.value);
                        } })))))));
    };
    const checkboxGroup = (field) => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement("label", null,
                field.boldLabel ? boldString(field.label) : field.label,
                ((_a = field.validations) === null || _a === void 0 ? void 0 : _a.includes('required')) && (React.createElement("span", { style: { color: 'red' } }, "\u00A0*"))),
            React.createElement("div", { className: 'o-inline-group' }, catalogs &&
                catalogs[field.catalog] &&
                catalogs[field.catalog].catalog.map((elem, index) => {
                    return (React.createElement("div", { key: `group-${index}`, className: 'o-inline-group__item' },
                        React.createElement(Check_1.BronsonFormCheck, { key: index, elementId: `${field.elementId}-${index}`, group: `group-${field.elementId}`, checked: (dataForm &&
                                dataForm[field.elementId] &&
                                dataForm[field.elementId].includes(elem[field.catalogId])) ||
                                false, defaultValue: elem[field.catalogId] ||
                                elem[field.catalogName], label: elem[field.catalogName], onChange: (change) => {
                                let value = change.value;
                                const data = (dataForm &&
                                    dataForm[field.elementId]) ||
                                    [];
                                value = data.includes(value)
                                    ? data.filter((item) => item !== value)
                                    : [...data, value];
                                onChangeDataForm(field.elementId, value);
                            } })));
                }))));
    };
    const dateInput = (field) => {
        var _a;
        const value = dataForm && dataForm[field.elementId]
            ? dataForm[field.elementId]
            : field.defaultValue || form_type_1.defaultValue;
        const getOptions = (datePickerOption) => {
            let options = {};
            if (datePickerOption === 'month-select') {
                const date = value.split(' ');
                const selectedMonth = Number((0, moment_dates_1.getMonthNumberByName)(date[0])) - constants_1.one;
                const selectedYear = Number(date[1]);
                options = {
                    altInput: true,
                    defaultDate: new Date(selectedYear, selectedMonth),
                    plugins: [(0, monthSelect_1.default)({ altFormat: 'F Y' })],
                };
                return options;
            }
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("label", null,
                field.boldLabel ? boldString(field.label) : field.label,
                ((_a = field.validations) === null || _a === void 0 ? void 0 : _a.includes('required')) && (React.createElement("span", { style: { color: 'red' } }, "\u00A0*"))),
            React.createElement(DatePicker_1.BronsonDatePicker, Object.assign({ className: 'date-test-class', testId: field.elementId, error: !!field.error, value: value, guide: true, onChange: (value) => onChangeDataForm(field.elementId, value.toString()), dateFormat: field.dateFormat || form_type_1.DateFormat['d/m/Y'], mode: field.mode || 'single', locale: 'es', disabled: field.isDisabled }, (field.minDate ? { minDate: field.minDate } : {}), (field.maxDate ? { maxDate: field.maxDate } : {}), (field.flatpickrOptions
                ? {
                    flatpickrOptions: getOptions(field.flatpickrOptions),
                }
                : {}))),
            field.error && (React.createElement("div", { className: 'c-error-message' },
                React.createElement("ul", null,
                    React.createElement("li", { className: 'u-mb-xsmall' }, field.error))))));
    };
    const buttonForm = (btn) => {
        return (React.createElement(Button_1.BronsonButton, { key: 'search-button', label: btn.label, click: btn.click, dataComponent: btn.dataComponent, config: btn.config }));
    };
    const textAreaInput = (field, newDefault) => (React.createElement("div", { key: field.elementId, className: 'o-layout__item' },
        React.createElement("label", null, field.boldLabel ? boldString(field.label) : field.label),
        React.createElement("div", { className: 'c-input  c-input--textarea' },
            React.createElement("textarea", { className: 'c-input__input', placeholder: field.placeholder, id: field.elementId, onChange: (event) => {
                    event.preventDefault();
                    onChangeDataForm(field.elementId, event.currentTarget.value);
                }, value: newDefault }))));
    const form = () => {
        const inputForm = [];
        formProvider.forEach((field) => {
            if (!field.hide) {
                const { type } = field;
                switch (type) {
                    case 'radio':
                        inputForm.push(React.createElement("div", { key: field.elementId, className: `o-layout__item  ${field.class ? field.class : 'u-1/3'}  u-1/1@s`, style: { backgroundColor: 'transparent' } }, radioButtonElement(field)));
                        break;
                    case 'customSelect':
                        const loadingCustomSelect = field.catalog && catalogs[field.catalog].isLoading;
                        inputForm.push(React.createElement("div", { key: field.elementId, className: `o-layout__item  ${field.class ? field.class : 'u-1/3'}  u-1/1@s` }, loadingCustomSelect
                            ? spinner()
                            : customSelectElement(field)));
                        break;
                    case 'select':
                        const loadingSelect = field.catalog && catalogs[field.catalog].isLoading;
                        inputForm.push(React.createElement("div", { key: field.elementId, className: `o-layout__item  ${field.class ? field.class : 'u-1/3'}  u-1/1@s` }, loadingSelect
                            ? spinner()
                            : selectElement(field)));
                        break;
                    case 'date':
                        inputForm.push(React.createElement("div", { key: field.elementId, className: `o-layout__item  ${field.class ? field.class : 'u-1/3'}  u-1/1@s` }, dateInput(field)));
                        break;
                    case 'text':
                    case 'number':
                        const hideArrow = type === 'number' ? 'numInputWrapper' : '';
                        inputForm.push(React.createElement("div", { key: field.elementId, className: `o-layout__item  ${field.class ? field.class : 'u-1/3'}  u-1/1@s ${hideArrow}`, style: { backgroundColor: 'transparent' } }, textElement(field)));
                        break;
                    case 'textarea':
                        const newDefault = dataForm && dataForm[field.elementId]
                            ? dataForm[field.elementId]
                            : field.defaultValue || form_type_1.defaultValue;
                        inputForm.push(textAreaInput(field, newDefault));
                    case 'checkboxGroup':
                        inputForm.push(React.createElement("div", { key: field.elementId, className: `o-layout__item  ${field.class || 'u-1/3 '}  u-1/1@s` }, checkboxGroup(field)));
                        break;
                    case 'label':
                        inputForm.push(React.createElement("div", { key: field.elementId, className: `o-layout__item  ${field.class || 'u-1/3 '} 'u-1/1@s'}` },
                            React.createElement("label", null, field.boldLabel
                                ? boldString(field.label)
                                : field.label)));
                        break;
                    case 'button':
                        inputForm.push(React.createElement("div", { key: `btn_${field.elementId}`, className: `o-layout__item  ${field.class || 'u-1/3 '} 'u-1/1@s'}` },
                            React.createElement("button", { id: field.elementId, className: field.styleClass, onClick: () => {
                                    onChangeDataForm(field.elementId, '');
                                }, disabled: field.isDisabled || false }, field.label)));
                        break;
                    case 'element':
                        inputForm.push(React.createElement("div", { id: field.elementId, key: field.elementId, className: `o-layout__item  ${field.class || 'u-1/3 '} 'u-1/1@s'}`, style: field.customStyle
                                ? field.customStyle
                                : undefined }, field.boldLabel
                            ? boldString(field.label)
                            : field.label));
                        break;
                    default:
                        inputForm.push(React.createElement("div", { id: field.elementId, key: field.elementId }));
                }
            }
        });
        if (searchButton)
            inputForm.push(React.createElement("div", { className: 'o-layout__item u-1/6 u-1/3@m u-1/1@s u-float-right u-pt' }, buttonForm(searchButton)));
        return inputForm;
    };
    return (React.createElement("div", { className: 'u-mb', id: formId !== null && formId !== void 0 ? formId : 'filter-form-component' },
        React.createElement("div", { className: 'o-layout' }, form())));
};
exports.BronsonFilterForm = BronsonFilterForm;
